export default __webpack_public_path__ + "static/media/settingsSelected.0e21b661.svg";